import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const followOnJob = {
  namespaced: true,
  state: {
    booking: '',
    bookingForm: '',
    isReturnBooking: false,
    followOnJobsForTaxi: []
  },
  getters,
  mutations,
  actions
}
